<template>
  <div class="container pad-btm15">
    <div class="blacklist-top">
      <div class="blacklist-top-box">
        <div class="icon iconfont icon-buxihuan"></div>
        <p>你在商品黑名单添加了 <span class="t_f23030">{{blockProductTotal || 0}}</span> 件商品</p>
      </div>
    </div>
    <div class="list-tip">以下商品已被屏蔽，将不会展现在商品列表中</div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false">
        <list-template
          :data-list="dataList"
          @deleteBlackProduct="deleteBlackProduct"
          @entoDetailPage="entoDetailPage">
        </list-template>
    </div>
    <segement-line
      v-if="!haveMore"
      line-text="没有更多商品啦">
    </segement-line>
    <segement-line
      v-if="haveMore"
      line-text="正在加载"
      :is-load="true">
    </segement-line>
  </div>
</template>

<script>
import SegementLine from '@/components/puppetComponent/SegementLine'
import ListTemplate from './children/ListTemplate'
import { Toast, Indicator } from 'mint-ui'
import { GetBlockProductList, DeleteBlockProduct } from '@/api/blacklist'

export default {
  data () {
    return {
      dataList: [],
      isLastOne: false,
      haveMore: false,
      scrollDisabled: false,
      blockProductTotal: 0
    }
  },
  components: {
    SegementLine,
    ListTemplate
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData (isDropDown = false) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      GetBlockProductList({
        HasStock: null,
        IsDropDown: isDropDown
      }).then(res => {
        Indicator.close()
        this.dataList = [...this.dataList, ...res.DataList]
        this.blockProductTotal = res.BlockProductTotal
        this.isLastOne = res.IsLastRecord
        if (res.IsLastRecord) {
          this.haveMore = false
        } else {
          this.haveMore = true
        }
        this.scrollDisabled = false
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 进入详情页
    entoDetailPage (productID, isFreeCard) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    },
    deleteBlackProduct (productId) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      DeleteBlockProduct({ productId: productId }).then(res => {
        Indicator.close()
        Toast('商品已恢复')
        this.dataList = []
        this.fetchData()
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    loadMore () {
      if (this.isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      this.fetchData(true)
    }
  }
}
</script>

<style scoped>
  .blacklist-top{
    display: flex;
    align-items: center;
    height: 65px;
    line-height: 65px;
    background: #fff;
    text-align: center;
  }
  .blacklist-top-box{
    display: flex;
    align-items: center;
    width: 94%;
    height: 35px;
    line-height: 35px;
    border-radius: 20px;
    padding: 0 15px;
    margin: 0 auto;
    box-sizing: border-box;
    background: #f5f5f5;
  }
  .blacklist-top-box .icon{
    margin-right: 8px;
  }
  .blacklist-dialog-text{
    padding-bottom: 20px;
    font-size: 14px;
    line-height: 20px;
  }
  .list-tip{
    color: #999;
    font-size: 15px;
    height: 42px;
    line-height: 42px;
    padding-left: 10px;
    box-sizing: border-box;
  }
</style>
